import React, { useState, useEffect } from "react";
import { Container, Form, Button, Row, Col, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faNoteSticky,
  faCalendar,
  faUserGroup,
  faSun,
  faMap,
  faClock,
  faPlus,
  faMinus,
  faMessage,
  faBabyCarriage,
  faWheelchair,
  faFloppyDisk,
  faSquarePhoneFlip,
} from "@fortawesome/free-solid-svg-icons";
import DropDownBabyChairs from "./inputs/DropDownBabyChairs";
import styled from "styled-components";
import PhoneField from "./PhoneField";

import { BabyChair } from "../icons/SvgIcons";

const OrangeInput = styled(Form.Control)`
  &:focus {
    border-color: #ee754c !important;
    box-shadow: 0 0 0 0.2rem rgba(238, 117, 76, 0.25) !important;
  }
`;

const ExtrasInside = styled.div`
  padding: 5px;
  width: 100%;
  margin-top: 10px;
  border-radius: 5px;
  border: ${(props) => (props.status ? "" : "1px solid gray")};
  cursor: pointer;
  color: ${(props) => (props.status ? "#ffffff" : "black")};
  background-color: ${(props) => (props.status ? "#EE754C" : "white")};
`;

/* Red outline container for PhoneField and Terms when invalid */
const RedOutlineBox = styled.div`
  border: ${(props) =>
    props.invalid ? "1px solid #D94B4B" : "1px solid transparent"};
  border-radius: 6px;
  padding: ${(props) => (props.pad ? "8px" : "0")};
`;

function StepThreeReservations({
  fullName,
  setFullName,
  email,
  setEmail,
  emailWS,
  setCountryCodeNumber,
  countryCodeNumber,
  setPhoneWithoutCountryCode,
  phoneWithoutCountryCode,
  Extras,
  isExtrasOpen,
  handleExtras,
  babyChairs,
  DivFlexStart,
  setBabyChairs,
  DivFlexEnd,
  numBabyChairs,
  existingBabyChairs = 0,
  handleBabyChange,
  limitPeopleBaby,
  isMessageOpen,
  setIsMessageOpen,
  isAccessOpen,
  message,
  setMessage,
  maxMessageLength,
  CustomSelect,
  accessabilities,
  setIsAccessOpen,
  setAccessability,
  accessability,
  setShowTermsAndConditions,
  phoneWS,
  fullNameWS,
  acceptTerms,
  setAcceptTerms,
  acceptTermsWS,
  from_restaurant,
  creating,
  restaurantNote,
  setRestaurantNote,
}) {
  let baby_chair_options = limitPeopleBaby?.baby_chair_numbers;

  const [isNoteOpen, setIsNoteOpen] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(false);

  useEffect(() => {
    if (restaurantNote.length > 0) {
      setIsNoteOpen(true);
    }
  }, [restaurantNote]);

  if (!limitPeopleBaby) {
    return null;
  }

  return (
    <>
      <Row
        style={{
          display: "flex",
          justifyContent: "start",
          textAlign: "start",
          marginTop: "10px",
        }}
      >
        <Col xs={12}>
          <Form.Label>Nome</Form.Label>
          <OrangeInput
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            onKeyDown={(e) => {
              if (
                ((e.target.value.match(/ /g) || []).length > 1 &&
                  e.key === " ") ||
                (e.target.value.length >= 20 &&
                  e.key !== "Backspace" &&
                  e.key !== "Delete")
              ) {
                e.preventDefault();
              }
            }}
            maxLength={20}
            required
            isInvalid={!!fullNameWS} // highlight in red when invalid
          />
        </Col>

        <Col xs={12}>
          <Form.Label>E-mail</Form.Label>
          <OrangeInput
            type="email"
            value={email}
            onChange={(e) => {
              if (!creating && !from_restaurant) return;
              setEmail(e.target.value);
            }}
            readOnly={!creating && !from_restaurant}
            required
            isInvalid={!!emailWS} // highlight in red when invalid
          />
        </Col>

        <Col xs={12}>
          <Form.Label>Telemóvel</Form.Label>
          <RedOutlineBox invalid={!!phoneWS} pad>
            <PhoneField
              initialFullPhone={`+${countryCodeNumber}${phoneWithoutCountryCode}`}
              countryCodeNumber={countryCodeNumber}
              setCountryCodeNumber={setCountryCodeNumber}
              phoneWithoutCountryCode={phoneWithoutCountryCode}
              setPhoneWithoutCountryCode={setPhoneWithoutCountryCode}
              isPhoneValid={isPhoneValid}
              setIsPhoneValid={setIsPhoneValid}
            />
          </RedOutlineBox>
        </Col>

        <Col xs={12}>
          <Row>
            <Col xs={12}>
              <Extras isExtrasOpen={isExtrasOpen} onClick={handleExtras}>
                Extras{" "}
                <FontAwesomeIcon
                  size="xl"
                  icon={isExtrasOpen ? faMinus : faPlus}
                  style={
                    isExtrasOpen ? { color: "#ffffff" } : { color: "#EE754C" }
                  }
                />
              </Extras>
            </Col>

            {isExtrasOpen && (
              <>
                <Col xs={12}>
                  <ExtrasInside
                    status={babyChairs || baby_chair_options.length === 0}
                    onClick={() => {
                      setBabyChairs(!babyChairs);
                    }}
                  >
                    <Row>
                      <Col xs={6}>
                        <DivFlexStart>
                          <BabyChair
                            width={25}
                            height={25}
                            strokeColor={
                              baby_chair_options.length === 0
                                ? "#D94B4B"
                                : babyChairs
                                ? "#ffffff"
                                : "#EE754C"
                            }
                          />
                          <span
                            className="ms-3"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            Cadeiras de bebé
                            {baby_chair_options.length === 0 &&
                              " (indisponíveis)."}
                          </span>
                        </DivFlexStart>
                      </Col>
                      <Col xs={6}>
                        <DivFlexEnd>
                          <FontAwesomeIcon
                            size="xl"
                            icon={babyChairs ? faMinus : faPlus}
                            style={
                              babyChairs || baby_chair_options.length === 0
                                ? { color: "#ffffff" }
                                : { color: "#EE754C" }
                            }
                          />
                        </DivFlexEnd>
                      </Col>
                    </Row>
                  </ExtrasInside>
                </Col>

                {babyChairs !== 0 && (
                  <Col xs={12} className="mt-3">
                    <DropDownBabyChairs
                      babyChairFree={baby_chair_options}
                      existingBabyChairs={existingBabyChairs}
                      fromRestaurant={from_restaurant}
                      initial={numBabyChairs}
                      onChange={handleBabyChange}
                    />
                  </Col>
                )}

                <Col xs={12}>
                  <ExtrasInside
                    status={isAccessOpen}
                    onClick={() => setIsAccessOpen(!isAccessOpen)}
                  >
                    <Row>
                      <Col xs={6}>
                        <DivFlexStart>
                          <FontAwesomeIcon
                            size="xl"
                            icon={faWheelchair}
                            style={
                              isAccessOpen
                                ? { color: "#ffffff" }
                                : { color: "#EE754C" }
                            }
                          />
                          <h7 className="ms-3">Acessibilidade</h7>
                        </DivFlexStart>
                      </Col>
                      <Col xs={6}>
                        <DivFlexEnd>
                          <FontAwesomeIcon
                            size="xl"
                            icon={isAccessOpen ? faMinus : faPlus}
                            style={
                              isAccessOpen
                                ? { color: "#ffffff" }
                                : { color: "#EE754C" }
                            }
                          />
                        </DivFlexEnd>
                      </Col>
                    </Row>
                  </ExtrasInside>

                  {isAccessOpen && (
                    <Col xs={12} className="mt-3">
                      <CustomSelect
                        items={accessabilities}
                        onSelectChange={(value) => setAccessability(value)}
                        selectedItem={accessability}
                        setItem={setAccessability}
                      />
                    </Col>
                  )}
                </Col>

                {/* creating message from customer */}
                {creating && (
                  <Col xs={12}>
                    <ExtrasInside
                      status={isMessageOpen}
                      onClick={() => setIsMessageOpen(!isMessageOpen)}
                    >
                      <Row>
                        <Col xs={6}>
                          <DivFlexStart>
                            <FontAwesomeIcon
                              size="xl"
                              icon={faMessage}
                              style={
                                isMessageOpen
                                  ? { color: "#ffffff" }
                                  : { color: "#EE754C" }
                              }
                            />
                            <h7 className="ms-3">Mensagem</h7>
                          </DivFlexStart>
                        </Col>
                        <Col xs={6}>
                          <DivFlexEnd>
                            <FontAwesomeIcon
                              size="xl"
                              icon={isMessageOpen ? faMinus : faPlus}
                              style={
                                isMessageOpen
                                  ? { color: "#ffffff" }
                                  : { color: "#EE754C" }
                              }
                            />
                          </DivFlexEnd>
                        </Col>
                      </Row>
                    </ExtrasInside>

                    {isMessageOpen && (
                      <Col xs={12} className="mt-3">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={message}
                          maxLength={maxMessageLength}
                          onChange={(e) => setMessage(e.target.value)}
                          required
                        />
                        <div className="text-right">
                          {message.length}/{maxMessageLength}
                        </div>
                      </Col>
                    )}
                  </Col>
                )}
              </>
            )}
          </Row>
        </Col>

        {/* Restaurant notes */}
        {from_restaurant && (
          <Col xs={12}>
            <ExtrasInside
              status={isNoteOpen}
              onClick={() => setIsNoteOpen(!isNoteOpen)}
            >
              <Row>
                <Col xs={6}>
                  <DivFlexStart>
                    <FontAwesomeIcon
                      size="xl"
                      icon={faNoteSticky}
                      style={
                        isNoteOpen ? { color: "#ffffff" } : { color: "#EE754C" }
                      }
                    />
                    <h7 className="ms-3">Nota interna</h7>
                  </DivFlexStart>
                </Col>
                <Col xs={6}>
                  <DivFlexEnd>
                    <FontAwesomeIcon
                      size="xl"
                      icon={isNoteOpen ? faMinus : faPlus}
                      style={
                        isNoteOpen ? { color: "#ffffff" } : { color: "#EE754C" }
                      }
                    />
                  </DivFlexEnd>
                </Col>
              </Row>
            </ExtrasInside>

            {isNoteOpen && (
              <Col xs={12} className="mt-1">
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={restaurantNote}
                  maxLength={maxMessageLength}
                  onChange={(e) => setRestaurantNote(e.target.value)}
                  required
                />
                <div className="text-right">
                  {restaurantNote.length}/{maxMessageLength}
                </div>
              </Col>
            )}
          </Col>
        )}

        {creating && !from_restaurant && (
          <Col xs={12} className="mt-4">
            <RedOutlineBox invalid={!!acceptTermsWS} pad>
              <div className="terms-and-conditions">
                <input
                  className="mt-2"
                  type="checkbox"
                  checked={acceptTerms}
                  onChange={() => setAcceptTerms(!acceptTerms)}
                />{" "}
                &nbsp;
                <span>
                  Li e aceito os &nbsp;
                  <a
                    onClick={() => setShowTermsAndConditions(true)}
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                  >
                    Termos e Condições
                  </a>
                  .
                </span>
              </div>
            </RedOutlineBox>
          </Col>
        )}
      </Row>
    </>
  );
}

export default StepThreeReservations;
